import { render, staticRenderFns } from "./FormCreateResearchPage2.vue?vue&type=template&id=60fda14f&scoped=true&"
import script from "./FormCreateResearchPage2.vue?vue&type=script&lang=js&"
export * from "./FormCreateResearchPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fda14f",
  null
  
)

export default component.exports